import React from 'react'
import { connect } from 'react-redux'
import UploadPage from '../containers/pages/UploadPage'
import config from '../resource/config.js'
import Main from './Main.js'
import Unauthorized from '../containers/pages/Unauthorized.js'
import * as actions from '../store/actions/actions'
const endpointUrl = config.apiBaseUrl + 'apbe/requestvalidation'
const _ = require('lodash')

class ApbeRequest extends React.Component {
	componentDidMount() {
		if (_.isNil(sessionStorage.request)) {
			var request = {
				userOrgIds: this.props.UserAssociatedOrgs.userOrgIds,
				cognitoId: this.props.UserAssociatedOrgs.roleCd,
				userName: this.props.UserAssociatedOrgs.userName
			}
			sessionStorage.request = JSON.stringify(request)
		} else if(sessionStorage.request === "{}"){
			sessionStorage.request = JSON.parse(sessionStorage.request)
			request = {
				userOrgIds: this.props.UserAssociatedOrgs.userOrgIds,
				cognitoId: this.props.UserAssociatedOrgs.roleCd,
				userName: this.props.UserAssociatedOrgs.userName
			}
			sessionStorage.request = JSON.stringify(request)
		}

		else {
			request = JSON.parse(sessionStorage.request)
		}
		this.props.onFetchRequest()
	}

	render(){
		if(this.props.unauthorized) {
			return (
				<Unauthorized />
			)
		} else {
			if(this.props.isLoading){
				return (
					<div role="progressbar" aria-valuetext="Loading…" className="cb-loader cb-loader-blue cb-loader-lg"></div>
				)
			} else {
				if(!this.props.currentRequest){
					return (
						<UploadPage
							apiAuthHeaders={this.props.apiHeaders}
							orgNames={this.props.orgNames}
							eligibleOrgIds={this.props.eligibleOrgIds}
							orgAiCodes={this.props.orgAiCodes}
							cogId={this.props.UserAssociatedOrgs.roleCd}
							userOrgIds={this.props.UserAssociatedOrgs.userOrgIds}
							userName={this.props.UserAssociatedOrgs.userName}
							UpdateType="1"
						/>
					)
				} else {
					return (
						<Main
							apiAuthHeaders={this.props.apiHeaders}
							fDataItems={this.props.currentRequest}
							requestCount={this.props.requestCount}
							userName={this.props.UserAssociatedOrgs.userName}
							orgNames={this.props.orgNames}
							eligibleOrgIds={this.props.eligibleOrgIds}
							orgAiCodes={this.props.orgAiCodes}
							userOrgIds={this.props.UserAssociatedOrgs.userOrgIds}
						/>
					)
				}
			}
		}
	}
}

const mapStateToProps = state => {
  return {
		apiHeaders: state.apiHeaders,
		orgNames: state.orgNames,
		eligibleOrgIds: state.eligibleOrgIds,
		orgAiCodes: state.orgAiCodes,
		currentRequest: state.currentRequest,
		requestCount: state.requestCount,
		isLoading: state.isLoading,
		unauthorized: state.unauthorized
  }
}

const mapDispatchToProps = dispatch => {
  return {
		onFetchRequest: () => dispatch(actions.asyncFetch(endpointUrl, sessionStorage.authSession, sessionStorage.request))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ApbeRequest)
